module.exports = __webpack_public_path__ + "img/1519035598.67363432.jpg";